<template>
  <div class="wrap">
    <DeliverySidebar
      :form="form"
      @changeIsSelectedPoiLocationGroup="changeIsSelectedPoiLocationGroup"
      class="sidebar"
    />
    <DeliveryContent
      :form="form"
      :isSelectedPoiLocationGroup="isSelectedPoiLocationGroup"
      class="content"
    />
  </div>
</template>

<script>
import DeliveryContent from './SimulationContentDeliveryContent'
import DeliverySidebar from './SimulationContentDeliverySidebar'
export default {
  name: 'SimulationModelContentDelivery',
  components: { DeliverySidebar, DeliveryContent },
  props: {
    form: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { isSelectedPoiLocationGroup: false }
  },
  methods: {
    changeIsSelectedPoiLocationGroup(status) {
      this.isSelectedPoiLocationGroup = status
    },
  },
}
</script>

<style scoped>
.wrap {
  padding: 0 !important;
  display: flex;
  height: 100%;
}
.content {
  flex: 1;
}
.sidebar {
  width: 280px;
  display: flex;
  flex-direction: column;
}
</style>
